<section class="bg-gradient-to-t from-black to-purple-900 h-[500px] flex items-center justify-center text-center text-white">
  <div class="max-w-2xl">
      <h1 class="text-4xl mb-5">Amazon Q Developer</h1>
      <p class="text-lg leading-relaxed mb-10">O assistente mais capaz com inteligência artificial para desenvolvimento de software</p>
      <a href="#" class="bg-blue-500 text-white py-4 px-6 rounded-lg hover:bg-blue-600">Saiba mais</a>
  </div>
</section>
